import { createVNode as _createVNode } from "vue";
/**
 * @author chenjizhong
 * @fileoverview 首页右侧锚点盒子
 */

import { defineComponent, reactive, nextTick, onMounted, onBeforeUnmount } from "vue";
export default defineComponent({
  name: "AnchorBoxHome",
  setup() {
    const state = reactive({
      navActive: 1
    });
    onMounted(() => {
      nextTick(() => {
        // document
        //   .getElementById("container-id")
        //   .addEventListener("scroll", scroll);
      });
    });
    onBeforeUnmount(() => {
      // document
      //   .getElementById("container-id")
      //   .removeEventListener("scroll", scroll);
    });
    // const scroll = () => {
    //   let scrollTop = document.getElementById("container-id").scrollTop;
    //   let height1 = document.getElementById("backtop").scrollHeight;
    //   let height2 = height1 + document.getElementById("honor-box").scrollHeight;
    //   let height3 = height2 + document.getElementById("match-box").scrollHeight;
    //   let height4 = height3 + document.getElementById("info-box").scrollHeight;
    //   let height5 = height4 + document.getElementById("video-box").scrollHeight;
    //   if (scrollTop === 0) {
    //     document.getElementById("q-btn").style.display = "none";
    //   } else {
    //     document.getElementById("q-btn").style.display = "block";
    //     if (0 < scrollTop && scrollTop < height1) {
    //       state.navActive = 1;
    //     } else if (height1 < scrollTop && scrollTop < height3) {
    //       state.navActive = 2;
    //     } else if (height3 < scrollTop && scrollTop < height4) {
    //       state.navActive = 3;
    //     } else if (height4 < scrollTop && scrollTop < height5) {
    //       state.navActive = 4;
    //     }
    //   }
    // };
    const handleClick = (id, active) => {
      state.navActive = active;
      document.querySelector(id).scrollIntoView(true);
      const scrollTop = document.getElementById("container-id").scrollTop;
      document.getElementById("container-id").scrollTop = scrollTop - 150;
    };
    return () => {
      return _createVNode("div", {
        "class": "nav-bg",
        "id": "q-btn"
      }, [_createVNode("div", {
        "class": "imgs"
      }, [_createVNode("a", null, [_createVNode("img", {
        "src": require(`@/assets/img/pc/nav-honor-home${state.navActive === 1 ? "-act" : ""}.png`),
        "class": "img-item",
        "onClick": () => handleClick("#honor-img", 1)
      }, null)]), _createVNode("img", {
        "class": "divide-box",
        "src": require(`@/assets/img/pc/nav-divide.png`)
      }, null), _createVNode("a", null, [_createVNode("img", {
        "class": "img-item",
        "src": require(`@/assets/img/pc/nav-match-home${state.navActive === 2 ? "-act" : ""}.png`),
        "onClick": () => handleClick("#ss-process", 2)
      }, null)]), _createVNode("img", {
        "class": "divide-box",
        "src": require(`@/assets/img/pc/nav-divide.png`)
      }, null), _createVNode("a", null, [_createVNode("img", {
        "class": "img-item",
        "src": require(`@/assets/img/pc/nav-info-home${state.navActive === 3 ? "-act" : ""}.png`),
        "onClick": () => handleClick("#hot-news", 3)
      }, null)]), _createVNode("img", {
        "class": "divide-box",
        "src": require(`@/assets/img/pc/nav-divide.png`)
      }, null), _createVNode("a", null, [_createVNode("img", {
        "class": "img-item",
        "src": require(`@/assets/img/pc/nav-video-home${state.navActive === 4 ? "-act" : ""}.png`),
        "onClick": () => handleClick("#selection-video", 4)
      }, null)]), _createVNode("img", {
        "class": "divide-box",
        "src": require(`@/assets/img/pc/nav-divide.png`)
      }, null), _createVNode("a", null, [_createVNode("img", {
        "class": "img-item",
        "src": require(`@/assets/img/pc/nav-backtop.png`),
        "onClick": () => handleClick("#backtop", 5)
      }, null)])])]);
    };
  }
});